import React from 'react';
import View from '../cruds/View';
import Edit from '../cruds/Edit';
import { notNullValidatorCancMutag } from '../cruds/validators';
import { Show_IfNOT_Mutagen_Cancerous, Show_If_Mutagen_Cancerous } from '../components/output/OutputBox';
import OutputText, { LocalizedOutputText, SimpleOutputText, LocalizedSimpleOutputText } from '../components/output/OutputText';
import OutputValue from '../components/output/OutputValue';
import RemoteInputSelect from '../components/input/RemoteInputSelect';
import RemoteInputNumber from '../components/input/RemoteInputNumber';
import DisabledSelectOutput from '../components/output/DisabledSelectOutput';
import Box, { SimpleBox, BoxEdit, SimpleBoxEdit } from '../components/container/Box';
import ButtonLink from '../components/output/ButtonLink';
import DownloadButton from '../components/output/DownloadButton';
import { ArrowRight } from 'react-feather';
import { Horizontal, Vertical, HorizontalInput, VerticalInput } from '../components/container/LayoutRow';
import { Switch, Route } from 'react-router-dom';
import EvaluationsArchive from './EvaluationsArchive';
import { decimalFormatter, booleanFormatter } from '../functions/textFormatter';
import './Evaluations.css';

const FATHER_ENTITY_ROUTE = 'substances/management';
const FATHER_ENTITY_NAME = 'departmentActivitySubstances';
const ENTITY_NAME = 'evaluations';
const ENTITY_ROUTE = 'evaluation';

const SubstanceOutputText = ({ value, style }) => (
  <span style={style}>{value}</span>
);

const Arrow = ({ style }) => (
  <span style={style}><ArrowRight /></span>
);

const CrudEdit = (props)  => {
  const basePath = buildFullEntity(props.parentId);
  const baseRoute = FATHER_ENTITY_ROUTE;

  const validators = [
	  notNullValidatorCancMutag('inhalationDistance', 'evaluations.err.inhalationDistance'),
	  notNullValidatorCancMutag('inhalationQuantity', 'evaluations.err.inhalationQuantity'),
	  notNullValidatorCancMutag('inhalationProperty', 'evaluations.err.inhalationProperty'),
	  notNullValidatorCancMutag('inhalationSystemType', 'evaluations.err.inhalationSystemType'),
	  notNullValidatorCancMutag('inhalationControlType', 'evaluations.err.inhalationControlType'),
	  notNullValidatorCancMutag('inhalationExposureTime', 'evaluations.err.inhalationExposureTime'),
	  notNullValidatorCancMutag('skinSystemType', 'evaluations.err.skinSystemType'),
	  notNullValidatorCancMutag('skinContactLevel', 'evaluations.err.skinContactLevel'),

	  notNullValidatorCancMutag('revelationCollectiveProtectionFactor', 'evaluations.err.revelationCollectiveProtectionFactor'),
	  notNullValidatorCancMutag('revelationProcessTemperature', 'evaluations.err.revelationProcessTemperature'),
	  notNullValidatorCancMutag('revelationChemicalPhysicalState', 'evaluations.err.revelationChemicalPhysicalState'),
	  notNullValidatorCancMutag('revelationAmountUsed', 'evaluations.err.revelationAmountUsed'),
	  notNullValidatorCancMutag('revelationHandlingTimeMinutes', 'evaluations.err.revelationHandlingTimeMinutes'),
	  notNullValidatorCancMutag('revelationFrequencyOfUseDays', 'evaluations.err.revelationFrequencyOfUseDays'),
  ];

  return (
    <Edit {...props}
          crudClassName="evaluations-edit"
          overrideTitle="evaluations.title"
          entityName={basePath}
          entityRoute={baseRoute}
          entityId="new"
          validators={validators}
          refreshFrom={basePath + '/evaluate'}
          signed
    >
      <HorizontalInput style={{ alignItems: 'flex-start' }}>
        <VerticalInput>
          <SimpleOutputText name="departmentName" label="evaluations.department" />
          <SimpleOutputText name="activityName" label="evaluations.activity" />
          <SimpleOutputText name="substanceCode" label="evaluations.substance" />
          <SimpleOutputText name="dpiUsage" label="evaluations.dpiUsage" />
          <SimpleOutputText name="usingDpc" label="evaluations.usingDpc" formatter={booleanFormatter} />
        </VerticalInput>
          
          
          <Show_If_Mutagen_Cancerous>  
          <VerticalInput>

          <LocalizedSimpleOutputText
              name="revelationProcessTemperaturePre"
              label="substancesManagement.revelationProcessTemperaturePre"
              prefix="substancesManagement.revelationProcessTemperatureValuesPre"
              style={{ marginTop: 10 }}
          />
        <SimpleOutputText name="revelationHandlingTimeMinutesPre" label="substancesManagement.revelationHandlingTimeMinutesPre" style={{ flex: 3 }} />    
        <SimpleOutputText name="revelationFrequencyOfUseDaysPre" label="substancesManagement.revelationFrequencyOfUseDaysPre" style={{ flex: 3 }} />
          
          </VerticalInput>

          </Show_If_Mutagen_Cancerous>  

          
          
          
          <Show_IfNOT_Mutagen_Cancerous>  
        <VerticalInput>    
        
          <BoxEdit label="substancesManagement.dailyQuantity.displayLabel">
            <VerticalInput>
              <HorizontalInput style={{ alignItems: 'center' }}>
                <SubstanceOutputText value="Max" />
                <SubstanceOutputText name="maxDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
                <SimpleOutputText name="maxDailyQuantity.unit" />
              </HorizontalInput>
              <HorizontalInput>
                <SubstanceOutputText value="Min" />
                <SubstanceOutputText name="minDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
                <SimpleOutputText name="minDailyQuantity.unit" />
              </HorizontalInput>
            </VerticalInput>
          </BoxEdit>
          <BoxEdit label="substancesManagement.presentQuantity.displayLabel" style={{ marginTop: 10 }}>
            <HorizontalInput style={{ alignItems: 'center' }}>
              <SubstanceOutputText value="Max" />
              <SubstanceOutputText name="maxActualQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
              <SimpleOutputText name="maxActualQuantity.unit" />
            </HorizontalInput>
          </BoxEdit>
          <LocalizedSimpleOutputText
              name="contactFrequency"
              label="substancesManagement.frequency.displayLabel"
              prefix="substancesManagement.contactFrequencyValues"
              style={{ marginTop: 10 }}
          />
          <LocalizedSimpleOutputText
              name="exposureTime"
              label="substancesManagement.expositionTime.displayLabel"
              prefix="substancesManagement.expositionTimeValues"
              style={{ marginTop: 10 }}
          />
        </VerticalInput>         
          
         </Show_IfNOT_Mutagen_Cancerous>  

      </HorizontalInput>
 
      <Show_If_Mutagen_Cancerous>    
		      <BoxEdit label="evaluations.revelation">
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputSelect
		        from={basePath + '/revelationCollectiveProtectionFactor'}
		        label="evaluations.revelationCollectiveProtectionFactor"
		        name="revelationCollectiveProtectionFactor"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationCollectiveProtectionFactorValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigP" label="evaluations.bigP" style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputSelect
		        from={basePath + '/revelationProcessTemperature'}
		        label="evaluations.revelationProcessTemperature"
		        name="revelationProcessTemperature"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationProcessTemperatureValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigT" label="evaluations.bigT" style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputSelect
		        from={basePath + '/revelationChemicalPhysicalState'}
		        label="evaluations.revelationChemicalPhysicalState"
		        name="revelationChemicalPhysicalState"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationChemicalPhysicalStateValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigS" label="evaluations.bigS" style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputSelect
		        from={basePath + '/revelationAmountUsed'}
		        label="evaluations.revelationAmountUsed"
		        name="revelationAmountUsed"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationAmountUsedValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigQ" label="evaluations.bigQ" style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputNumber
		        label="evaluations.revelationHandlingTimeMinutes"
		        name="revelationHandlingTimeMinutes"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationAmountUsedValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigE" label="evaluations.bigE" formatter={decimalFormatter(2)}  style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      <HorizontalInput style={{ alignItems: 'center' }}>
		      <RemoteInputNumber
		        label="evaluations.revelationFrequencyOfUseDays"
		        name="revelationFrequencyOfUseDays"
		        optionValueName="value"
		        optionLabelName="label"
		        style={{ flex: 3, flexBasis: 'auto' }}
		        localize="evaluations.revelationFrequencyOfUseDaysValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <SimpleOutputText name="bigF" label="evaluations.bigF" formatter={decimalFormatter(2)}  style={{ flex: 3 }} />
		   	  </HorizontalInput>
		      </BoxEdit>
      </Show_If_Mutagen_Cancerous>
      <Show_If_Mutagen_Cancerous>
		      <BoxEdit className="final-result" label="evaluations.lcanc.LcancLabel">
			      <SimpleOutputText name="lcanc" formatter={decimalFormatter(2)} />
			      <LocalizedSimpleOutputText name="lcancType" prefix="evaluations.lcancType" />
		      </BoxEdit>
      </Show_If_Mutagen_Cancerous>
      
      
      <Show_IfNOT_Mutagen_Cancerous>    
		      	<BoxEdit label="evaluations.inhalation">
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <RemoteInputSelect
		            from={basePath + '/inhalationDistance'}
		            label="evaluations.inhalationDistance"
		            name="inhalationDistance"
		            optionValueName="value"
		            optionLabelName="label"
		            style={{ flex: 3, flexBasis: 'auto' }}
		            localize="evaluations.inhalationDistanceValues"
		          />
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="smallD" label="evaluations.smallD" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <VerticalInput style={{ flex: 3, flexBasis: 'auto' }}>
		            <RemoteInputSelect
		              from={basePath + '/inhalationQuantity'}
		              label="evaluations.inhalationQuantity"
		              name="inhalationQuantity"
		              optionValueName="value"
		              optionLabelName="label"
		              style={{ flex: 3, flexBasis: 'auto' }}
		              localize="evaluations.inhalationQuantityValues"
		            />
		            <RemoteInputSelect
		              from={basePath + '/inhalationProperty'}
		              label="evaluations.inhalationProperty"
		              name="inhalationProperty"
		              optionValueName="value"
		              optionLabelName="label"
		              style={{ flex: 3, flexBasis: 'auto' }}
		              localize="evaluations.inhalationPropertyValues"
		            />
		          </VerticalInput>
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="bigD" label="evaluations.bigD" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <RemoteInputSelect
		            from={basePath + '/inhalationSystemType'}
		            label="evaluations.inhalationSystemType"
		            name="inhalationSystemType"
		            optionValueName="value"
		            optionLabelName="label"
		            style={{ flex: 3, flexBasis: 'auto' }}
		            localize="evaluations.inhalationSystemTypeValues"
		          />
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="bigU" label="evaluations.u" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <RemoteInputSelect
		            from={basePath + '/inhalationControlType'}
		            label="evaluations.inhalationControlType"
		            name="inhalationControlType"
		            optionValueName="value"
		            optionLabelName="label"
		            style={{ flex: 3, flexBasis: 'auto' }}
		            localize="evaluations.inhalationControlTypeValues"
		          />
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="bigC" label="evaluations.c" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <RemoteInputSelect
		            from={basePath + '/inhalationExposureTime'}
		            label="evaluations.inhalationExposureTime"
		            name="inhalationExposureTime"
		            optionValueName="value"
		            optionLabelName="label"
		            style={{ flex: 3, flexBasis: 'auto' }}
		            localize="substancesManagement.expositionTimeValues"
		          />
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="bigI" label="evaluations.i" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <VerticalInput style={{ flex: 3 }}>
		            <SimpleOutputText name="scoreP" label="evaluations.scoreP" />
		            <SimpleOutputText name="scoreH" label="evaluations.scoreH" />
		          </VerticalInput>
		          <SimpleBoxEdit style={{ flex: 3 }} className="result-box">
		            <SimpleOutputText name="eInal" label="evaluations.einal" />
		            <SimpleOutputText name="rInal" label="evaluations.rinal" />
		            <SimpleOutputText name="rInalH" label="evaluations.rinalH" />
		          </SimpleBoxEdit>
		        </HorizontalInput>
		      </BoxEdit>
	  </Show_IfNOT_Mutagen_Cancerous>
      <Show_IfNOT_Mutagen_Cancerous> 
		      <BoxEdit label="evaluations.skin">
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <VerticalInput style={{ flex: 3 }}>
		            <RemoteInputSelect
		              from={basePath + '/skinSystemType'}
		              label="evaluations.skinSystemType"
		              name="skinSystemType"
		              optionValueName="value"
		              optionLabelName="label"
		              style={{ flex: 3, flexBasis: 'auto' }}
		              localize="evaluations.skinSystemTypeValues"
		            />
		            <RemoteInputSelect
		              from={basePath + '/skinContactLevel'}
		              label="evaluations.skinContactLevel"
		              name="skinContactLevel"
		              optionValueName="value"
		              optionLabelName="label"
		              style={{ flex: 3,  flexBasis: 'auto' }}
		              localize="evaluations.skinContactLevelValues"
		            />
		          </VerticalInput>
		          <Arrow style={{ flex: 1 }} />
		          <SimpleOutputText name="ecute" label="evaluations.ecute" style={{ flex: 3 }} />
		        </HorizontalInput>
		        <HorizontalInput style={{ alignItems: 'center' }}>
		          <VerticalInput style={{ flex: 3 }}>
		            <SimpleOutputText name="scoreP" label="evaluations.scoreP" />
		            <SimpleOutputText name="scoreH" label="evaluations.scoreH" />
		          </VerticalInput>
		          <Arrow style={{ flex: 1 }} />
		          <SimpleBoxEdit style={{ flex: 3 }} className="result-box">
		            <SimpleOutputText name="rcute" label="evaluations.rcute" />
		            <SimpleOutputText name="rcuteH" label="evaluations.rcuteH" />
		          </SimpleBoxEdit>
		        </HorizontalInput>
		      </BoxEdit>
      </Show_IfNOT_Mutagen_Cancerous>
      <Show_IfNOT_Mutagen_Cancerous>
		      <BoxEdit className="final-result" label="evaluations.rcum.rcumLabel">
		        <SimpleOutputText name="rcum" formatter={decimalFormatter(2)} />
		        <LocalizedSimpleOutputText name="rcumType" prefix="evaluations.cumulativeRiskType" />
		      </BoxEdit>
	  </Show_IfNOT_Mutagen_Cancerous>
      <Show_IfNOT_Mutagen_Cancerous>
		      <BoxEdit className="final-result" label="evaluations.rcumH.rcumHLabel">
		        <SimpleOutputText name="rcumH" formatter={decimalFormatter(2)} />
		        <LocalizedSimpleOutputText name="rcumHType" prefix="evaluations.cumulativeRiskType" />
		      </BoxEdit>
	  </Show_IfNOT_Mutagen_Cancerous>
      

    </Edit>
  );
};

const ViewButtons = ({ entityRoute, entityId }, resource) => (
  <div>
    <DownloadButton from={'departmentActivitySubstances/evaluations/' + (resource ? resource.departmentActivitySubstanceId : -1)}
        type="application/pdf"
        extension="pdf"
        iconType="button"
        style={{ marginLeft: '10px' }}
    />
    <ButtonLink
        to={'/' + entityRoute}
        label="evaluations.viewArchive"
        style={{ marginLeft: '10px' }}
    />
    <ButtonLink
        to={'/' + FATHER_ENTITY_ROUTE}
        label="general.close"
        style={{ marginLeft: '10px' }}
    />
  </div>
);

const buildFullEntity = (parentId) => {
  return [FATHER_ENTITY_NAME, parentId, ENTITY_NAME].join('/');
};

const buildFullRoute = (parentId) => {
  return [FATHER_ENTITY_ROUTE, parentId, ENTITY_ROUTE].join('/');
};

const CrudView = props => (
  <View crudClassName="evaluations-view" title="evaluations.last"
        entityName={buildFullEntity(props.parentId)}
        entityRoute={buildFullRoute(props.parentId)}
        entityId={props.match.params.number}
        buttons={ViewButtons}>
    <Horizontal style={{ alignItems: 'flex-start' }}>
      <Vertical>
        <OutputText name="departmentName" label="evaluations.department" />
        <OutputText name="activityName" label="evaluations.activity" />
        <OutputText name="substanceCode" label="evaluations.substance" />
        <OutputText name="dpiUsage" label="evaluations.dpiUsage" />
        <OutputText name="usingDpc" label="evaluations.usingDpc" formatter={booleanFormatter} />
      </Vertical>
      
      
        <Show_If_Mutagen_Cancerous>
        <Vertical>
        <LocalizedOutputText
        name="revelationProcessTemperaturePre"
        label="substancesManagement.revelationProcessTemperaturePre"
        prefix="substancesManagement.revelationProcessTemperatureValuesPre"
        style={{ marginTop: 10 }}
    />
        <OutputText name="revelationHandlingTimeMinutesPre"  label="substancesManagement.revelationHandlingTimeMinutesPre"/>
        <OutputText name="revelationFrequencyOfUseDaysPre"  label="substancesManagement.revelationFrequencyOfUseDaysPre"/>
        </Vertical>
        </Show_If_Mutagen_Cancerous>

        
      
      <Show_IfNOT_Mutagen_Cancerous>
      
      <Vertical>
        <Box label="substancesManagement.dailyQuantity.displayLabel">
          <Vertical>
            <Horizontal style={{ alignItems: 'center' }}>
              <SubstanceOutputText value="Max" />
              <OutputValue name="maxDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
              <OutputValue name="maxDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
            </Horizontal>
            <Horizontal>
              <SubstanceOutputText value="Min" />
              <OutputValue name="minDailyQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
              <OutputValue name="minDailyQuantity.unit" />
            </Horizontal>
          </Vertical>
        </Box>
        <Box label="substancesManagement.presentQuantity.displayLabel" style={{ marginTop: 10 }}>
          <Horizontal style={{ alignItems: 'center' }}>
            <SubstanceOutputText value="Max" />
            <OutputValue name="maxActualQuantity.value" style={{ marginLeft: '10px', marginRight: '5px' }} />
            <OutputValue name="maxActualQuantity.unit" />
          </Horizontal>
        </Box>
        <LocalizedOutputText
            name="contactFrequency"
            label="substancesManagement.frequency.displayLabel"
            prefix="substancesManagement.contactFrequencyValues"
            style={{ marginTop: 10 }}
        />
        <LocalizedOutputText
            name="exposureTime"
            label="substancesManagement.expositionTime.displayLabel"
            prefix="substancesManagement.expositionTimeValues"
            style={{ marginTop: 10 }}
        />
      </Vertical>
        </Show_IfNOT_Mutagen_Cancerous>
    </Horizontal>

    <Show_If_Mutagen_Cancerous>
		 <Box label="evaluations.revelation">
		   <Horizontal style={{ alignItems: 'center' }}>
		      <DisabledSelectOutput
		          name="revelationCollectiveProtectionFactor"
		          label="evaluations.revelationCollectiveProtectionFactor"
		          style={{ flex: 3 }}
		          localize="evaluations.revelationCollectiveProtectionFactorValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigP" label="evaluations.bigP" style={{ flex: 3 }} />
		    </Horizontal>
		   <Horizontal style={{ alignItems: 'center' }}>
		      <DisabledSelectOutput
		          name="revelationProcessTemperature"
		          label="evaluations.revelationProcessTemperature"
		          style={{ flex: 3 }}
		          localize="evaluations.revelationProcessTemperatureValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigT" label="evaluations.bigT" style={{ flex: 3 }} />
		    </Horizontal>
		   <Horizontal style={{ alignItems: 'center' }}>
		      <DisabledSelectOutput
		          name="revelationChemicalPhysicalState"
		          label="evaluations.revelationChemicalPhysicalState"
		          style={{ flex: 3 }}
		          localize="evaluations.revelationChemicalPhysicalStateValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigS" label="evaluations.bigS" style={{ flex: 3 }} />
		    </Horizontal>
		   <Horizontal style={{ alignItems: 'center' }}>
		      <DisabledSelectOutput
		          name="revelationAmountUsed"
		          label="evaluations.revelationAmountUsed"
		          style={{ flex: 3 }}
		          localize="evaluations.revelationAmountUsedValues"
		      />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigQ" label="evaluations.bigQ" style={{ flex: 3 }} />
		    </Horizontal>
		   <Horizontal style={{ alignItems: 'center' }}>
		      <OutputText name="revelationHandlingTimeMinutes" label="evaluations.revelationHandlingTimeMinutes" style={{ flex: 3 }} />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigE" label="evaluations.bigE" style={{ flex: 3 }} />
		    </Horizontal>
		   <Horizontal style={{ alignItems: 'center' }}>
		      <OutputText name="revelationFrequencyOfUseDays" label="evaluations.revelationFrequencyOfUseDays" style={{ flex: 3 }} />
		      <Arrow style={{ flex: 1 }} />
		      <OutputText name="bigF" label="evaluations.bigF" style={{ flex: 3 }} />
		    </Horizontal>			      
		 </Box>
    </Show_If_Mutagen_Cancerous> 
    <Show_If_Mutagen_Cancerous>
	    <Box className="final-result"  label="evaluations.lcanc.LcancLabel">
	      <OutputText name="lcanc" formatter={decimalFormatter(2)} />
	      <LocalizedOutputText name="lcancType" prefix="evaluations.lcancType" />
	    </Box>
    </Show_If_Mutagen_Cancerous>
    
    <Show_IfNOT_Mutagen_Cancerous>
		    <Box label="evaluations.inhalation">
		      <Horizontal style={{ alignItems: 'center' }}>
		        <DisabledSelectOutput
		            name="inhalationDistance"
		            label="evaluations.inhalationDistance"
		            style={{ flex: 3 }}
		            localize="evaluations.inhalationDistanceValues"
		        />
		        <Arrow style={{ flex: 1 }} />
		        <OutputText name="smallD" label="evaluations.smallD" style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <Vertical style={{ flex: 3 }}>
		          <DisabledSelectOutput
		              name="inhalationQuantity"
		              label="evaluations.inhalationQuantity"
		              localize="evaluations.inhalationQuantityValues"
		          />
		          <DisabledSelectOutput
		              name="inhalationProperty"
		              label="evaluations.inhalationProperty"
		              localize="evaluations.inhalationPropertyValues"
		          />
		        </Vertical>
		        <Arrow style={{ flex: 1 }} />
		        <OutputText name="bigD" label="evaluations.bigD" style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <DisabledSelectOutput
		            name="inhalationSystemType"
		            label="evaluations.inhalationSystemType"
		            style={{ flex: 3 }}
		            localize="evaluations.inhalationSystemTypeValues"
		        />
		        <Arrow style={{ flex: 1 }} />
		        <OutputText name="bigU" label="evaluations.u" style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <DisabledSelectOutput
		            name="inhalationControlType"
		            label="evaluations.inhalationControlType"
		            style={{ flex: 3 }}
		            localize="evaluations.inhalationControlTypeValues"
		        />
		        <Arrow style={{ flex: 1 }} />
		        <OutputText name="bigC" label="evaluations.c"  style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <DisabledSelectOutput
		            name="inhalationExposureTime"
		            label="evaluations.inhalationExposureTime"
		            style={{ flex: 3 }}
		            localize="substancesManagement.expositionTimeValues"
		        />
		        <Arrow style={{ flex: 1 }} />
		          <OutputText name="bigI" label="evaluations.i" style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <Vertical style={{ flex: 3 }}>
		          <OutputText name="scoreP" label="evaluations.scoreP" />
		          <OutputText name="scoreH" label="evaluations.scoreH" />
		        </Vertical>
		        <Arrow style={{ flex: 1 }} />
		        <SimpleBox style={{ flex: 3 }} className="result-box">
		          <OutputText name="eInal" label="evaluations.einal" />
		          <OutputText name="rInal" label="evaluations.rinal" />
		          <OutputText name="rInalH" label="evaluations.rinalH" />
		        </SimpleBox>
		      </Horizontal>
		    </Box>
    </Show_IfNOT_Mutagen_Cancerous>
    <Show_IfNOT_Mutagen_Cancerous>
		    <Box label="evaluations.skin">
		      <Horizontal style={{ alignItems: 'center' }}>
		        <Vertical style={{ flex: 3 }}>
		          <DisabledSelectOutput
		            name="skinSystemType"
		            label="evaluations.skinSystemType"
		            localize="evaluations.skinSystemTypeValues"
		          />
		          <DisabledSelectOutput
		            name="skinContactLevel"
		            label="evaluations.skinContactLevel"
		            localize="evaluations.skinContactLevelValues"
		          />
		        </Vertical>
		        <Arrow style={{ flex: 1 }} />
		        <OutputText name="ecute" label="evaluations.ecute" style={{ flex: 3 }} />
		      </Horizontal>
		      <Horizontal style={{ alignItems: 'center' }}>
		        <Vertical style={{ flex: 3 }}>
		          <OutputText name="scoreP" label="evaluations.scoreP" />
		          <OutputText name="scoreH" label="evaluations.scoreH" />
		        </Vertical>
		        <Arrow style={{ flex: 1 }} />
		        <SimpleBox style={{ flex: 3 }} className="result-box">
		          <OutputText name="rcute" label="evaluations.rcute" />
		          <OutputText name="rcuteH" label="evaluations.rcuteH" />
		        </SimpleBox>
		      </Horizontal>
		    </Box>
    </Show_IfNOT_Mutagen_Cancerous>
    <Show_IfNOT_Mutagen_Cancerous>
		    <Box className="final-result"  label="evaluations.rcum.rcumLabel">
		      <OutputText name="rcum" formatter={decimalFormatter(2)} />
		      <LocalizedOutputText name="rcumType" prefix="evaluations.cumulativeRiskType" />
		    </Box>
      </Show_IfNOT_Mutagen_Cancerous>
      <Show_IfNOT_Mutagen_Cancerous>
		    <Box className="final-result" label="evaluations.rcumH.rcumHLabel">
		      <OutputText name="rcumH" formatter={decimalFormatter(2)} />
		      <LocalizedOutputText name="rcumHType" prefix="evaluations.cumulativeRiskType" />
		    </Box>
      </Show_IfNOT_Mutagen_Cancerous>
  </View>
);

const CrudList = props => (
  <EvaluationsArchive entityName={buildFullEntity(props.parentId)}
    entityRoute={buildFullRoute(props.parentId)}
  />
);

const Evaluations = props => {
  const basePath = props.match.url;
  const parentId = props.match.params.number;

  return (
    <Switch>
      <Route exact path={basePath} render={props => <CrudList parentId={parentId} {...props} />} />
      <Route exact path={basePath + '/:number/view'} render={props => <CrudView parentId={parentId} {...props} />} />
      <Route exact path={basePath + '/new'} render={props => <CrudEdit parentId={parentId} {...props} />} />
    </Switch>
  );
};

export default Evaluations;



// WEBPACK FOOTER //
// ./src/main/pages/Evaluations.js